import Button from "components/ui/Button";
import Select from "components/ui/Select";
import { Filter, RotateCcw } from "lucide-react";
import React from "react";

interface Filters {
	status: string;
	priceRange: string;
	propertyType: string;
	search: string;
}

interface SalesFiltersProps {
	filters: Filters;
	onFilterChange: (filters: Partial<Filters>) => void;
}

const SalesFilters: React.FC<SalesFiltersProps> = ({ filters, onFilterChange }) => {
	const handleReset = () => {
		onFilterChange({
			status: "all",
			priceRange: "all",
			propertyType: "all",
			search: "",
		});
	};

	const statusOptions = [
		{ value: "all", label: "All Status" },
		{ value: "active", label: "Active" },
		{ value: "pending", label: "Pending" },
		{ value: "occupied", label: "Occupied" },
		{ value: "withdrawn", label: "Withdrawn" },
	];

	const priceRangeOptions = [
		{ value: "all", label: "All Prices" },
		{ value: "0-200000", label: "Under ₦200K" },
		{ value: "200000-500000", label: "₦200K - ₦500K" },
		{ value: "500000-1000000", label: "₦500K - ₦1M" },
		{ value: "1000000-2000000", label: "₦1M - ₦2M" },
		{ value: "2000000-99999999", label: "Above ₦2M" },
	];

	const propertyTypeOptions = [
		{ value: "all", label: "All Types" },
		{ value: "house", label: "House" },
		{ value: "apartment", label: "Apartment" },
		{ value: "condo", label: "Condo" },
		{ value: "townhouse", label: "Townhouse" },
		{ value: "commercial", label: "Commercial" },
	];

	return (
		<div className="bg-card rounded-lg border border-border p-6">
			<div className="flex items-center gap-4 mb-4">
				<div className="flex items-center gap-2">
					<Filter className="w-4 h-4 text-muted-foreground" />
					<span className="text-sm font-medium text-foreground">Filters</span>
				</div>
			</div>
			<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
				<div>
					<label className="block text-sm font-medium text-foreground mb-2">
						Status
					</label>
					<Select
						value={filters?.status}
						onValueChange={(value) => onFilterChange({ status: value as string })}
						options={statusOptions}
					/>
				</div>

				<div>
					<label className="block text-sm font-medium text-foreground mb-2">
						Price Range
					</label>
					<Select
						value={filters?.priceRange}
						onValueChange={(value) => onFilterChange({ priceRange: value as string })}
						options={priceRangeOptions}
					/>
				</div>

				<div>
					<label className="block text-sm font-medium text-foreground mb-2">
						Property Type
					</label>
					<Select
						value={filters?.propertyType}
						onValueChange={(value) => onFilterChange({ propertyType: value as string })}
						options={propertyTypeOptions}
					/>
				</div>

				<div className="flex items-end">
					<Button
						variant="outline"
						onClick={handleReset}
						className="w-full flex items-center justify-center gap-2"
					>
						<RotateCcw className="w-4 h-4" />
						Reset
					</Button>
				</div>
			</div>
		</div>
	);
};

export default SalesFilters;
